<template>
  <div
    :class="['rb-diamond-selector', { 'rb-explorer': !selectors }]"
    ref="elDiamondSelector"
  >
    <div class="rb-diamond-controls">
      <div class="rb-tabs">
        <a
          :class="['rb-tab', { 'rb-active': listingMode === 'all' }]"
          href="#"
          id="btn-all-diamonds"
          @click.prevent="setListingMode($event, 'all')"
          >All Diamonds ({{ diamondsMeta?.totalElements || 0 }})</a
        >
        <a
          :class="['rb-tab', { 'rb-active': listingMode === 'fav' }]"
          href="#"
          @click.prevent="setListingMode($event, 'fav')"
          id="btn-favorite-diamonds"
          >Favorites ({{
            favoriteDiamondsFilteredData
              ? favoriteDiamondsFilteredData.diamonds.length
              : 0
          }})</a
        >
        <!-- <a href="#" @click.prevent="addDiamond">Test Product</a> -->
      </div>
      <div class="rb-right">
        <view-controls />
        <button
          class="rb-btn-filters"
          aria-label="Show Filters"
          id="btn-filters"
          @click.prevent="openFilters"
          v-if="listingMode !== 'fav'"
        >
          <span>Filters</span>
          <icon-filters />
        </button>
      </div>
    </div>
    <sku-search
      :selected-options="selectedOptions"
      :mappings="mappings"
      mode="mobile"
      v-if="showSkuSearch"
    />
    <applied-filters
      :applied-filters="appliedFilters"
      @rb-display-update="appliedFiltersDisplayUpdate"
    />
    <div class="rb-diamond-content" :style="style">
      <diamonds-table
        :data="data"
        :selected-options="selectedOptions"
        :diamonds-data="diamondsDisplayData"
        :favorites="favoriteDiamondsData"
        v-if="displayMode === 'table'"
        :selectors="selectors"
        :api="api"
        :data-price="dataPrice"
        :show-head="!hasNoResults"
        :combine-price="combinePrice"
      />
      <diamonds-grid
        :data="data"
        :selected-options="selectedOptions"
        :diamonds-data="diamondsDisplayData"
        v-if="displayMode === 'grid'"
        :selectors="selectors"
        :api="api"
        :data-price="dataPrice"
        :favorites="favoriteDiamondsData"
        :combine-price="combinePrice"
      />
      <load-more
        v-if="
          enableLoadMore &&
          !isLoadingDiamonds &&
          listingMode !== 'fav' &&
          listingMode !== 'search'
        "
        >LoadMore</load-more
      >
      <div v-if="hasNoResults" class="rb-no-results">
        No diamonds match your selected criteria. Please
        <a href="/pages/contact" target="_blank">contact us</a> so our Client
        Care team can personally assist you.
      </div>
    </div>
  </div>
</template>
<script>
import ChildMixin from "@/mixins/ChildMixin";
import DiamondsMixin from "@/mixins/DiamondsMixin";
import CommMixin from "@/mixins/CommMixin";
import TrackMixin from "@/mixins/TrackMixin";
import HeightMixin from "@/mixins/HeightMixin";
import DiamondsTable from "@/components/DiamondsTable";
import DiamondsGrid from "@/components/DiamondsGrid";
import AppliedFilters from "@/components/AppliedFilters";
import LoadMore from "@/components/LoadMore";
import ViewControls from "@/components/ViewControls";
import SkuSearch from "@/components/SkuSearch";
import IconFilters from "@/components/icons/IconFilters";
import { getFavoriteDiamonds, isMobile, searchDiamondsBySku } from "../lib";
export default {
  mixins: [HeightMixin, ChildMixin, DiamondsMixin, CommMixin, TrackMixin],
  components: {
    DiamondsTable,
    DiamondsGrid,
    AppliedFilters,
    LoadMore,
    ViewControls,
    SkuSearch,
    IconFilters,
  },
  props: {
    api: {
      type: Object,
    },
    selectors: {
      type: Boolean,
      default: true,
    },
    mappings: {
      type: Object,
    },
    combinePrice: {
      type: Boolean,
      default: true,
    },
    enableV360: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      isLoadingDiamonds: false,
      listingMode: "all",
      displayMode: "table",
      searchActive: false,
      appliedFilters: [],
      favoriteDiamondsData: { diamonds: [] },
      searchDiamondsData: { diamonds: [] },
      dataPrice: null,
    };
  },
  mounted: function () {
    this.initEvents();
    this.getFavoriteDiamonds();
    if (isMobile()) {
      this.broadcast("rb-set-display-mode", { mode: "table" });
    } else {
      this.broadcast("rb-set-display-mode", { mode: "grid" });
    }
    // console.log("api", this.api);
    this.mode = "table";
  },
  computed: {
    showSkuSearch: function () {
      if (!isMobile()) {
        return true;
      } else {
        // console.log(
        //   "here",
        //   this.appliedFilters.filter((f) => f.type !== "shape")
        // );
        return (
          this.appliedFilters.filter((f) => f.type !== "shape").length === 0
        );
      }
    },
    diamondsDisplayData: function () {
      if (this.listingMode === "all")
        return this.filterDiamondsWithV360(this.diamondsData);
      if (this.listingMode === "fav") return this.favoriteDiamondsFilteredData;
      if (this.listingMode === "search")
        return this.filterDiamondsWithV360(this.searchDiamondsData);
      return this.diamondsData;
    },

    favoriteDiamondsFilteredData: function () {
      var shapeData = this.selectedOptions.find(
        (selectedOption) => selectedOption.step.id === "shape"
      );
      if (!shapeData || !shapeData.choice) return { diamonds: [] };
      return {
        diamonds: this.favoriteDiamondsData.diamonds.filter((diamond) => {
          var shapeValue = shapeData.choice.label;
          if (shapeValue === "Round Brilliant") shapeValue = "Round";
          return diamond.shape.indexOf(shapeValue) > -1;
        }),
      };
    },
    hasNoResults: function () {
      if (
        this.listingMode !== "all" &&
        this.diamondsDisplayData.diamonds.length === 0
      )
        return true;
      if (
        this.listingMode === "all" &&
        !this.isLoadingDiamonds &&
        this.diamondsMeta &&
        this.diamondsMeta.empty
      )
        return true;
      return false;
    },
  },
  methods: {
    filterDiamondsWithV360: function (diamonds) {
      /*
      if video_url does not contain MP4 -> display this stone
      if video_url is null or video_url is empty -> validate the default_video.video_url
      if validating the default_video.video_url  -> check for v360
      if no v360 -> display stone*/
      if (!this.enableV360) {
        var filteredDiamonds = diamonds.diamonds.filter((diamond) => {
          var videoUrlIsMp4 =
            diamond.video_url && diamond.video_url.indexOf("mp4") > -1;
          var defaultVideoIsMp4 =
            diamond.default_video &&
            diamond.default_video.video_url &&
            diamond.default_video.video_url.indexOf("mp4") > -1;
          // var hasVideoUrlv360 = diamond.video_url
          //   ? diamond.video_url.indexOf("v360") > -1
          //   : false;
          // var hasDefaultVideoUrlv360 =
          //   diamond.default_video && diamond.default_video.video_url
          //     ? diamond.default_video.video_url.indexOf("v360") > -1
          //     : false;
          //return !hasVideoUrlv360 && !hasDefaultVideoUrlv360;
          return videoUrlIsMp4 || defaultVideoIsMp4;
        });
        // console.log(filteredDiamonds);
        return { ...diamonds, diamonds: filteredDiamonds };
      }

      return diamonds;
    },
    onUpdatePrice: function (data) {
      this.dataPrice = data;
    },
    initEvents: function () {
      this.subscribe("rb-apply-filters", this.onApplyFilters);
      this.subscribe("rb-step-display-update", this.onStepDisplayUpdate);
      this.subscribe("rb-update-price", this.onUpdatePrice);
      this.subscribe("rb-loading-diamonds", this.onLoadingDiamonds);
      this.subscribe("rb-loaded-diamonds", this.onLoadedDiamonds);
      this.subscribe("rb-set-display-mode", this.onSetDisplayMode);
      this.subscribe("rb-reset-listing-mode", this.onResetListingMode);
      this.subscribe("rb-search-sku", this.onSearchSku);
    },
    onSearchSku: function (data) {
      this.searchBySku(data.shape, data.sku);
    },
    onSetDisplayMode: function (data) {
      this.displayMode = data.mode;
    },
    onLoadingDiamonds: function () {
      this.isLoadingDiamonds = true;
    },
    onLoadedDiamonds: function () {
      this.isLoadingDiamonds = false;
    },
    onApplyFilters: function (appliedFilters) {
      // console.log("appliedFilters stepdiamond", appliedFilters);
      this.appliedFilters = appliedFilters;
    },
    onStepDisplayUpdate: function (step) {
      if (step.id === "diamond") {
        // this.listingMode = "all";
        //this.broadcast("rb-load-diamonds");
      }
    },
    setDisplayMode: function (mode) {
      this.displayMode = mode;
    },
    onResetListingMode: function () {
      this.listingMode = "all";
    },
    openFilters: function (event) {
      this.broadcast("rb-open-filters");
      this.trackEvent(
        this.formatTracking(this.getTrackId(event), this.TRACK_CLICK),
        this.getTrackId(event)
      );
    },
    appliedFiltersDisplayUpdate: function () {
      this.$nextTick(() => {
        this.updateHeight();
      });
    },
    getFavoriteDiamonds: function () {
      var favDiamonds = getFavoriteDiamonds();
      this.favoriteDiamondsData = { diamonds: favDiamonds };
    },
    setListingMode: function (event, mode) {
      this.listingMode = mode;
      this.trackEvent(
        this.formatTracking(this.getTrackId(event), this.TRACK_CLICK),
        this.getTrackId(event)
      );
    },
    searchBySku: async function (shape, sku) {
      //console.log("searching", shape, sku, this.api); //692-879
      const skuDiamonds = await searchDiamondsBySku(
        this.api.laReserve.baseUrl,
        this.api.laReserve.apiEndpoints,
        shape,
        sku
      );
      this.setListingMode({ currentTarget: { id: "rb-search" } }, "search");
      this.searchDiamondsData = {
        diamonds: skuDiamonds.diamonds,
      };
    },
  },
};
</script>
